import { Segment } from "semantic-ui-react";

import type { QuestionGroup } from "models";

type ParentQuestionGroupsProps = {
  questionGroups: QuestionGroup[];
};

export const ParentQuestionGroups = ({ questionGroups }: ParentQuestionGroupsProps) => (
  <>
    {questionGroups
      .toSorted((a, b) => a.ordering - b.ordering)
      .map(questionGroup => (
        <Segment key={questionGroup.id} className="question-group parent-question-group">
          <div className="question-group-header">
            <span className="question-group-name">{questionGroup.name}</span>
          </div>

          {questionGroup.questions
            ?.toSorted((a, b) => a.ordering - b.ordering)
            .map(question => (
              <div key={`${question.id}-${question.ordering}`} className="question-item">
                {question.title}
              </div>
            ))}
        </Segment>
      ))}
  </>
);
